import { render, staticRenderFns } from "./DashboardAdminTemplate.vue?vue&type=template&id=ba2defc4&"
import script from "./DashboardAdminTemplate.vue?vue&type=script&lang=js&"
export * from "./DashboardAdminTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports